import PropTypes from 'prop-types';
import React, {useState, useRef, useEffect} from 'react';
import classNames from 'classnames';

import locales from 'openblock-l10n';
import styles from './language-selector.css';

// Add Hindi, Kannada, Assamese and Bengali to locales
locales.hi = { name: 'हिन्दी' };
locales.kn = { name: 'ಕನ್ನಡ' };
locales.as = { name: 'অসমীয়া' };
locales.bn = { name: 'বাংলা' };
locales.tn = { name: 'தமிழ்' };
locales.te = { name: 'తెలుగు' };
locales.ml = { name: 'മലയാളം' };
locales.gu = { name: 'ગુજરાતી' };
locales.mr = { name: 'मराठी' };

// supported languages to exclude from the menu, but allow as a URL option
const ignore = ['zh-cn', 'ru', 'zh-tw'];

const LanguageSelector = ({ currentLocale, label, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        // Use capture phase to ensure it catches clicks even if children stop propagation
        document.addEventListener('mousedown', handleClickOutside, true);
        document.addEventListener('touchstart', handleClickOutside, true);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside, true);
            document.removeEventListener('touchstart', handleClickOutside, true);
        };
    }, []);

    const handleSelect = (locale) => {
        if (onChange) {
            onChange({target: {value: locale}});
        }
        setIsOpen(false);
    };

    return (
        <div ref={containerRef} className={styles.customLanguageSelector}>
            <div 
                className={styles.triggerArea} 
                aria-label={label} 
                onClick={() => setIsOpen(!isOpen)}
            />
            {isOpen && (
                <div className={styles.dropdownMenu}>
                    {Object.keys(locales)
                        .filter(l => !ignore.includes(l))
                        .map(locale => (
                            <div
                                key={locale}
                                className={classNames(styles.dropdownItem, {
                                    [styles.activeItem]: locale === currentLocale
                                })}
                                onClick={() => handleSelect(locale)}
                            >
                                {locales[locale].name}
                            </div>
                        ))}
                </div>
            )}
        </div>
    );
};

LanguageSelector.propTypes = {
    currentLocale: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func
};

export default LanguageSelector;
